/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import type { StackResourceEolStatus } from '@modules/ui-types/eolStatus'

import { hasReachedEol, isApproachingEol } from '@/lib/eolStatus'

import messages from './messages'

import type { FunctionComponent } from 'react'

interface Props {
  resourceEolStatus: StackResourceEolStatus
}

const EndOfLifeWarningTitle: FunctionComponent<Props> = ({ resourceEolStatus }) => {
  if (isApproachingEol(resourceEolStatus)) {
    return <FormattedMessage {...messages.approachingEolTitle} />
  }

  if (hasReachedEol(resourceEolStatus)) {
    return <FormattedMessage {...messages.reachedEolTitle} />
  }

  return null
}

export default EndOfLifeWarningTitle
